export default "__VITE_ASSET__B0hSfMHx__"